import Vue from 'vue'
import { configure, use, run } from 'system'

import { log } from 'utils/console'
import logger from 'modules/logger'
import user from 'modules/user'
import home from 'modules/home'

import Root from './views/root'

import mRouter from './router'
// import VeeValidate from 'vee-validate'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/app.css'
import locale from 'element-ui/lib/locale/lang/en'

import VueI18n from 'vue-i18n'
import VueLazyload from 'vue-lazyload'
import VueBus from 'vue-bus'
import 'lib-flexible'
import EdmodoHeader from '../components/edmodo/header'
import EdmodoFooter from '../components/edmodo/footer'
Vue.component(EdmodoHeader.name, EdmodoHeader)
Vue.component(EdmodoFooter.name, EdmodoFooter)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'images/img/el_portrait.png',
  attempt: 2
})
Vue.use(ElementUI, { locale })
// Vue.use(VeeValidate, { locale: 'zh_CN' })
Vue.use(VueI18n)
Vue.use(VueBus)

const i18n = new VueI18n({
  locale: 'zh_CN',
  messages: {
    'zh_CN': require('../i18n/zh_CN'),
    'en': require('../i18n/en')
  }
})

/**
 * 全局配置
 */
configure({
  // 项目名称
  name: 'PLATO',
  // 项目版本号
  version: '1.0',
  // 系统自动将 component 挂载到 element
  element: '#app',
  i18n,
  component: Root
})

/**
 * 调试相关
 */
__DEV__ && use(logger)

use(home)
use(user)

/**
 * Run Modules
 */
run(({ router, store }, done) => {
  log('%c[PLATO] %cLet\'s go!', 'font-weight: bold', 'color: green; font-weight: bold')
  mRouter(router, store)
  done()
})



// WEBPACK FOOTER //
// ./src/application/bootstrap.js